module.controller('dashboardCommercialManagerCtrl', [ '$filter', '$timeout', '$scope', '$rootScope', '$state', 'alertService', 'dateUtilService', 'dashboardService', 'dataIni', dashboardCommercialManagerCtrlFn ]);

function dashboardCommercialManagerCtrlFn($filter, $timeout, $scope, $rootScope, $state, alertService, dateUtil, dashboardService, dataIni) {
	var vm = $scope;

	var animation;
	var animationTran = {
		id : 0,
		step : 1,
		start : 0,
		end : 0,
		direction : 0,
		current : 0,
		timeAnimation : 10,
		duration : 450,
		callback : onTransition
	};
	var maxSize = 400;

	vm.mode = 1;
	vm.dashboardInfo = {};
	vm.donutData = [];
	vm.filters = {};
	vm.ckDisabled = false;
	vm.datePicker = {};
	vm.apiDonut = {};
	vm.dataBar = {};
	vm.totalSampleStates = {};
	vm.mensajeEstado = "Estado Actual";

	/*
	 * Opciones del datepicker
	 */
	vm.opts = {
		locale : {
			applyClass : 'btn-green',
			applyLabel : "Elegir",
			fromLabel : "desde",
			format : "YYYY-MM-DD",
			toLabel : "a",
			cancelLabel : 'Cancelar',
			customRangeLabel : 'Personalizado'
		},
		ranges : {
			'Estado Actual' : [ '', '' ],
			'Últimos 7 dias' : [ moment().subtract(6, 'days').startOf('day'), moment().endOf('day') ],
			'Últimos 30 dias' : [ moment().subtract(29, 'days').startOf('day'), moment().endOf('day') ],
			'Este mes' : [ moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day') ]
		},
		autoApply : true,
		eventHandlers : {
			'apply.daterangepicker' : onApplyDatePicker
		},
		dateLimit : {
			month : 2
		}
	};

	vm.porTomar = [ {
		state : SAMPLE_STATE.WAITING_FOR_SCHEDULE,
		name : function() {
			return 'Sin programación:';
		}
	}, {
		state : SAMPLE_STATE.SCHEDULED,
		name : function() {
			return vm.mode == 1 ? 'Programadas:' : 'Se programaron:';
		}
	}, {
		state : SAMPLE_STATE.ASIGNED,
		name : function() {
			return vm.mode == 1 ? 'Asignadas:' : 'Se asignaron:';
		}
	}, {
		state : SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED,
		name : function() {
			return vm.mode == 1 ? 'Esperando visita:' : 'En espera de visita:';
		}
	}, {
		state : SAMPLE_STATE.TAKEN_NOT_SIGNED,
		name : function() {
			return vm.mode == 1 ? 'Tomadas:' : 'Sin firmar:';
		}
	}];

	vm.enProceso = [ {
		state : SAMPLE_STATE.TAKEN,
		name : function() {
			return vm.mode == 1 ? 'Tomadas:' : 'Se tomaron:';
		}
	}, {
		state : SAMPLE_STATE.ADMITED,
		name : function() {
			return vm.mode == 1 ? 'Admitidas:' : 'Se admitieron:';
		}
	}, {
		state : SAMPLE_STATE.ANALYZING,
		name : function() {
			return vm.mode == 1 ? 'Analizando:' : 'Pasaron a analizando:';
		}
	}, {
		state : SAMPLE_STATE.ANALYZED,
		name : function() {
			return vm.mode == 1 ? 'Analizadas:' : 'Se analizaron:';
		}
	}, ];

	vm.finalizadas = [ {
		state : SAMPLE_STATE.REPORTED,
		name : function() {
			return vm.mode == 1 ? 'Reportadas:' : 'Se reportaron:';
		}
	}, {
		state : SAMPLE_STATE.NOT_TAKEN,
		name : function() {
			return vm.mode == 1 ? 'No tomadas:' : 'No se tomaron:';
		}
	}, {
		state : SAMPLE_STATE.NOT_CONFORM,
		name : function() {
			return vm.mode == 1 ? 'No conforme:' : 'Fueron no conforme:';
		}
	}, {
		state : SAMPLE_STATE.CANCELED,
		name : function() {
			return vm.mode == 1 ? 'Canceladas:' : 'Se cancelaron:';
		}
	}, ];

	/*
	 * Si se cambia el valor del checkbox
	 */
	vm.checkboxChange = function() {
		var donutData = [];
		var tsBefore = getTotalDataSelected(vm.donutData);
		SAMPLE_STATE.values().forEach(function(state) {
			if (vm.filters[state.enumName]) {
				var val = vm.totalSampleStates[state.enumName] | 0;
				var item = {
					label : state.name,
					value : val,
					color : getcolorFromClass(state.className)
				};
				donutData.push(item);
			}
		});
		vm.donutData = donutData;
		var tsAfter = getTotalDataSelected(vm.donutData);
		console.log(tsBefore, tsAfter);

		transitionAnimation(tsBefore, tsAfter);
		/*
		 * Se desabilitan los checkbox mientras se hace la trnasicion para que
		 * no haya conflictos
		 */
		vm.ckDisabled = true;
		$timeout(function() {
			vm.ckDisabled = false;
		}, vm.options.chart.duration + 50);
	}

	vm.search = function(startDate, endDate) {

		if (startDate.isValid() && endDate.isValid()) {
			var start = dateUtil.date2String(startDate);
			var end = dateUtil.date2String(endDate);
			dashboardService.getCMByDays(start, end).then(function(response) {
				vm.mode = 2;
				vm.dashboardInfo = response.getData();
				setInfo();
			}, function(response) {
			});
		} else {
			dashboardService.getCM().then(function(response) {
				vm.mode = 1;
				vm.dashboardInfo = response.getData();
				setInfo();
			}, function(response) {
			});
		}
	}

	/**
	 * Se ejecuta al iniciar
	 */
	function init() {
		vm.mode = 1;
		animationTran.duration = vm.options.chart.duration;
		if (dataIni.status) {
			vm.dashboardInfo = dataIni.response.getData();
			setInfo();
		}
	}

	function setInfo() {

		// Se pone el Titulo del grafico de la Dona
		setDonutTitle();

		vm.ckDisabled = true;
		vm.donutData = [];
		vm.totalSampleStates = {};
		vm.dashboardInfo.historyInfo.forEach(function(d) {
			d.consolidateDate = dateUtil.formatMomentDate(d.consolidateDate);
		});

		vm.dataBar = generateData();

		var mainInfo = vm.dashboardInfo.mainInfo;

		if (mainInfo == null || mainInfo.totalSamples <= 0)
			return;

		if (vm.mode == 1)
			vm.totalSampleStates = mainInfo.totalSampleStates;
		else
			vm.totalSampleStates = mainInfo.totalSampleStatesChange;

		var donutData = [];
		SAMPLE_STATE.values().forEach(function(state) {
			var val = vm.totalSampleStates[state.enumName] | 0;
			var item = {
				label : state.name,
				value : val,
				color : getcolorFromClass(state.className)
			};
			donutData.push(item);
			vm.filters[state.enumName] = true;
		});
		vm.donutData = donutData;
		vm.ckDisabled = false;

		// Se inicia la animación para el cambio del numero de muestras
		// seleccionadas
		transitionAnimation(animationTran.current, vm.dashboardInfo.mainInfo.totalSamples);

		// Se pone el mensaje del eje X del grafico de barras
		//vm.optionsBar.chart.xAxis.axisLabel = getAxisMonths();

	}

	function getAxisMonths() {
		var meses = [];

		vm.dashboardInfo.historyInfo.forEach(function(d) {
			var m = d.consolidateDate.format("MMMM");
			if (!meses.includes(m)) {
				meses.push(m);
			}
		});

		return meses.join(', ');

	}

	function transitionAnimation(start, end) {
		if (start == end)
			return;
		// se calcula el paso de la animacion
		animationTran.step = Math.ceil((animationTran.timeAnimation * Math.abs(start - end)) / animationTran.duration);
		animationTran.step = animationTran.step == 0 ? 1 : animationTran.step;
		animationTran.current = start;
		animationTran.start = start;
		animationTran.end = end;
		if (animationTran.start < animationTran.end)
			animationTran.direction = 0;
		else
			animationTran.direction = 1;
		animationTran.id = setInterval(animationTran.callback, animationTran.timeAnimation);
	}

	function onTransition() {
		var cmp = true;
		if (animationTran.direction == 0) {
			cmp = (animationTran.current >= animationTran.end);
			animationTran.current += animationTran.step;
		} else {
			cmp = (animationTran.current <= animationTran.end);
			animationTran.current -= animationTran.step;
		}

		if (cmp) {
			updateTextNumber(animationTran.end);
			clearInterval(animationTran.id);
		} else {
			updateTextNumber(animationTran.current);
		}
	}

	vm.options = {
		chart : {
			type : 'pieChart',
			margin : {
				top : -40,
				right : -25,
				bottom : -25,
				left : -25,
			},
			// height : 200,
			donut : true,
			x : function(d) {
				return d.label;
			},
			y : function(d) {
				return d.value;
			},
			showLabels : false,
			pie : {
				startAngle : function(d) {
					return d.startAngle - Math.PI
				},
				endAngle : function(d) {
					return d.endAngle - Math.PI
				}
			},
			noData : "No hay datos disponibles",
			donutRatio : 0.7,
			duration : 450,
			showLegend : false,
			dispatch : {
				renderEnd : donutRenderEnd
			},
			tooltip : {
				valueFormatter : function(d, i) {
					return d3.format(',.0f')(d);
					// return pie.valueFormat()(d, i);
				}
			}
		},
		title : {
			enable : true,
			html : "Total muestras",
			className : "number-dash-total"
		},
	};

	vm.optionsBar = {
		chart : {
			type : 'multiBarChart',
			height : 450,
			clipEdge : true,
			duration : 450,
			stacked : false,
			useInteractiveGuideline : true,
			controlLabels : {
				stacked : "Apilado",
				grouped : "Agrupado"
			},
			noData : "No hay datos disponibles",
			xAxis : {
				axisLabel : 'Día',
				showMaxMin : true,
//				tickFormat : function(d) {
//					return d3.format(',.0f')(d);
//				}
			},
			yAxis : {
				axisLabel : 'Total muestras',

				tickFormat : function(d) {
					return d3.format(',.0f')(d);
				}
			}
		}
	};

	function generateData() {

		var i = 0;
		var pt = {
			key : "Por tomar",
			values : []

		};
		var ep = {
			key : "En proceso",
			values : []

		};
		var fi = {
			key : "Finalizadas",
			values : []

		};

		vm.dashboardInfo.historyInfo.forEach(function(d) {
			var ps = d.states.totalSampleStates;
			if (vm.mode != 1)
				ps = d.states.totalSampleStatesChange;

			pt.values.push({
				x : d.consolidateDate.format("DD-MMM"),
				y : getPorTomar(ps)
			});
			ep.values.push({
				x : d.consolidateDate.format("DD-MMM"),
				y : getEnProceso(ps)
			});
			fi.values.push({
				x : d.consolidateDate.format("DD-MMM"),
				y : getFinalizadas(ps)
			});
		});

		return [ pt, ep, fi ];
	}

	function getPorTomar(ps) {
		var val = ps.WAITING_FOR_SCHEDULE;
		val += ps.SCHEDULED;
		val += ps.ASIGNED;
		val += ps.SAMPLE_ELEMENT_CHECKED;
		val += ps.TAKEN_NOT_SIGNED;
		return val;
	}

	function getEnProceso(ps) {
		var val = ps.TAKEN;
		val += ps.ADMITED;
		val += ps.ANALYZING;
		val += ps.ANALYZED;
		return val;
	}

	function getFinalizadas(ps) {
		var val = ps.REPORTED;
		val += ps.NOT_TAKEN;
		val += ps.NOT_CONFORM;
		val += ps.CANCELED;
		return val;
	}

	function donutRenderEnd(e) {

		$timeout(function() {
			var dft = $("#chartDiv");
			var hei = dft[0].clientWidth;
			if (hei > maxSize)
				hei = maxSize;
			if (vm.options.chart.height != hei)
				vm.options.chart.height = hei;
		}, 10);

		var donutScope = vm.apiDonut.getScope();
		var svg = donutScope.svg;
		var titles = svg.selectAll("g.nv-pie .nv-pie-title");
		var availableWidth = svg[0][0].clientWidth;
		var availableHeight = svg[0][0].clientHeight;
		var donutRatio1 = 0.6;
		var donutRatio2 = 0.3;

		if (titles[0].length == 0) {
			var donut = svg.selectAll("g.nv-pie").filter(function(d, i) {
				return i == 1;
			});

			var ts = getTotalDataSelected(donutScope.data);

			// Inserting text
			var t1 = "Muestras";
			var t2 = "Seleccionadas";

			var tam = Math.min(availableWidth, availableHeight) * donutRatio1 * 2;
			var tam1 = tam / (t1.length + 2);
			var tam2 = tam / (t2.length + 2);
			tam = Math.min(tam1, tam2);	

			donut.insert("text", "g").text(t1).attr("class", "nv-pie-title").attr("text-anchor", "middle").attr("transform", "translate(0, -" + tam + ")").attr("dy", "0.35em").style("font-size", tam + "px");

			donut.insert("text", "g").text(t2).attr("class", "nv-pie-title").attr("text-anchor", "middle").attr("transform", "translate(0, 0)").attr("dy", "0.35em").style("font-size", tam + "px");

			var tamN = (Math.min(availableWidth, availableHeight)) * donutRatio2 * 2 / (ts.toString().length + 2);

			donut.insert("text", "g").text(ts.toString()).attr("class", "nv-pie-title").attr("text-anchor", "middle").attr("transform", "translate(0, " + (tam + 5) + ")").attr("dy", "0.35em").style("font-size",
					tamN + "px").style("font-weight", "bold");

		} else {
			/*
			 * titles[0].forEach(function(t) { t.style.fontSize =
			 * (Math.min(availableWidth, availableHeight)) * donutRatio1 * 2 /
			 * (t.textContent.length + 2) + "px"; });
			 */
			// updateTextNumber(ts);
		}

	}

	function getTotalDataSelected(data) {
		var donutScope = vm.apiDonut.getScope();
		var ts = 0;
		if (data.length == 0) {
			return 0;
		} else if (data.length == 1) {
			ts = data[0].value;
		} else {
			ts = data.reduce(function(a, b) {
				var t = a.value == undefined ? a : a.value;
				return t + b.value;
			});
		}
		return ts;
	}

	function updateTextNumber(num) {
		var donutScope = vm.apiDonut.getScope();
		var svg = donutScope.svg;
		var texts = svg.selectAll("g.nv-pie .nv-pie-title");
		if (texts.length <= 0)
			return;
		if (texts[0].length <= 0)
			return;
		var numberText = texts[0][texts[0].length - 1];
		numberText.textContent = num;
	}

	function setDonutTitle() {
		if (vm.dashboardInfo.mainInfo == null) {
			vm.options.title.html = "...";
			return;
		}
		if (vm.mode == 1)
			vm.options.title.html = "<span class='number-text'>Total de</br>muestras</span> <span class='number-number'>" + vm.dashboardInfo.mainInfo.totalSamples + "</span>"
		else
			vm.options.title.html = "<span class='number-text'>Estados</br>de muestras</span> <span class='number-number'>" + vm.dashboardInfo.mainInfo.totalSamples + "</span>"
	}

	$(window).resize(function() {
		var dft = $("#chartDiv");
		var hei = dft[0].clientWidth;
		if (hei > maxSize)
			hei = maxSize;
		vm.options.chart.height = hei;
	});

	function getcolorFromClass(classCss) {
		var color = window.getComputedStyle(document.querySelector('.' + classCss)).getPropertyValue('color');

		color = color.substring(4, color.length - 1).replace(/ /g, '').split(',');
		color = color.map(function(c) {
			return parseInt(c);
		});
		return rgbToHex(color[0], color[1], color[2]);
	}

	function rgbToHex(r, g, b) {
		return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
	}

	function componentToHex(c) {
		var hex = c.toString(16);
		return hex.length == 1 ? "0" + hex : hex;
	}

	/**
	 * Eventos Datepicker
	 */
	function onApplyDatePicker(ev, picker) {
		var sel = false;
		for ( var property in vm.opts.ranges) {
			if (vm.opts.ranges.hasOwnProperty(property)) {
				console.log(vm.opts.ranges[property]);
				if (moment.isMoment(vm.opts.ranges[property][0]) && moment.isMoment(vm.opts.ranges[property][0])) {
					if (vm.opts.ranges[property][0].isSame(vm.datePicker.startDate) && vm.opts.ranges[property][1].isSame(vm.datePicker.endDate)) {
						console.log(property);
						vm.mensajeEstado = property;
						sel = true;
						break;
					}
				}
			}
		}
		if (!vm.datePicker.startDate.isValid() || !vm.datePicker.endDate.isValid()) {
			vm.mensajeEstado = "Estado Actual";
			sel = true;
		}
		if (!sel)
			vm.mensajeEstado = "Personalizado";

		vm.search(vm.datePicker.startDate, vm.datePicker.endDate);
	}

	vm.consolidateByDayPruebas = function() {
		dashboardService.consolidateByDayPruebas();
	}

	init();
}